import * as React from "react";
import {
  backGImage,
  btnWhite,
  container,
  description,
  inner,
  logo,
  teaserLink,
  title,
} from "./HelloRewardsBanner.module.scss";
import BackgroundImage from "gatsby-background-image";
import { StaticImage } from "gatsby-plugin-image";
import { getImage } from "gatsby-plugin-image";
import { convertToBgImage } from "gbimage-bridge";
import { Link } from "gatsby";

export const Container: React.FC<any> = (props) => {
  return <div className={container}>{props.children}</div>;
};

export const Content: React.FC<any> = (props) => {
  const isLoggedIn = false;
  return (
    <div className={inner}>
      <StaticImage
        src={"../../../images/favicon-32x32.png"}
        alt="Travel Pass"
        className={logo}
        placeholder="blurred"
        layout="fixed"
        formats={["png", "webp"]}
        width={84}
      />
      <h3 className={title}>{props.field_title}</h3>
      <p className={description}>{props.field_description}</p>
      <Link
        to={
          props.field_link && isLoggedIn
            ? "/account"
            : props.field_link.url || "/join-travel-pass"
        }
        className={btnWhite}
      >
        <span>
          {props.field_link && isLoggedIn
            ? "View Account"
            : props.field_link.title || "Join Now"}
        </span>
      </Link>
      <Link
        aria-label={`Learn More for ${props.field_title}`}
        to={
          props.field_learn_more_link
            ? props.field_learn_more_link.url
            : "/travel-pass"
        }
        className={teaserLink}
      >
        {props.field_learn_more_link
          ? props.field_learn_more_link.title
          : "Learn More"}
      </Link>
    </div>
  );
};

export const BackGroundImage: React.FC<any> = (props) => {
  const backgroundImg = props.relationships.field_media
    ? props.relationships.field_media.relationships.field_media_file.publicUrl
    : null;
  return (
    <div
      style={{ backgroundImage: `url(${backgroundImg})` }}
      className={container}
    >
      <Content {...props} />
    </div>
  );
};

export const TeaserImage: React.FC<any> = (props) => {
  const childImageSharp = props.relationships.field_media_image?.gatsbyImage;
  const _image = getImage(childImageSharp);
  const _bgImage = convertToBgImage(_image);
  return (
    <BackgroundImage
      {..._bgImage}
      preserveStackingContext
      className={backGImage}
    ></BackgroundImage>
  );
};

export const MobileView: React.FC<any> = (props) => {
  const TeaserImage = props.relationships.field_teaser_image
    ? props.relationships.field_teaser_image.relationships.field_media_image
        .gatsbyImage
    : null;
  const _image = getImage(TeaserImage);
  const _bgImage = convertToBgImage(_image);
  return (
    <BackgroundImage
      {..._bgImage}
      preserveStackingContext
      className={backGImage}
    >
      <Content {...props} />
    </BackgroundImage>
  );
};
